import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import PopupHeader from '../../popupHeader';
import Modal from 'components/shared/modal/content';
import { showDeleteWaitingAreaModal } from 'actions/modal.js';
import { deleteWaitingArea } from 'actions/waitingArea.js';
import { removeWAInEntityList } from 'actions/organisation.js';
import { displayGlobalMessage } from 'actions/globalMessage';
import {
  canIUseVCM,
  redirectUserToWaitingAreasfterLogin,
  redirectUserToOrgUnitfterLogin,
} from 'businessLogic/authorizator';

export default function WaitingAreaDeleteWAModal(props) {
  const dispatch = useDispatch();
  const [deletingWA, setDeletingWA] = useState(false);

  const confirmDeleteWA = () => {
    setDeletingWA(true);
    let cb = (hideOrNot) => {
      let isOnEntityListingPage = window.getState().organisationsReducer.isOnEntityListingPage;
      // If it's on entity admin Page
      if (!!isOnEntityListingPage) {
        let lastCb = (hideOrNot) => {
          setDeletingWA(false);
          dispatch(showDeleteWaitingAreaModal(hideOrNot));
          if (!hideOrNot && props.cbAfterDeletion) {
            props.cbAfterDeletion();
          }
        };
        dispatch(removeWAInEntityList(props.waitingArea.id, props.waitingArea.orgNetworkId, lastCb));
      } else {
        setDeletingWA(false);
        if (!hideOrNot) {
          dispatch(showDeleteWaitingAreaModal(hideOrNot));
        }
      }
    };

    dispatch(deleteWaitingArea(props.waitingArea.id, props.waitingArea.name, cb));
  };

  const closeConfirmationModal = () => {
    dispatch(showDeleteWaitingAreaModal(false));
  };

  let removeBtnClasses =
    'ui labeled icon button icon left-text color-button mrbnull color-button-hover mrpcrxs color-white mrlnull max-width';
  return (
    <Modal show={true} hideWhenClickAway={false} isSingleColumnModal={true} className="remove-tag single-column-modal">
      <PopupHeader
        hideHelp={true}
        title={window.APP.LANGUAGE.DeleteWaitingAreaModal.Title}
        subtitle={(props.waitingArea ? props.waitingArea.name : '') + ' (' + props.waitingArea.organisationName + ')'}
      />
      <div className="content">
        <div className="main-ui-container content-horizontally-centred mrrnull">
          <div id="righthandfloatingpanel">
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <h4 className="title-sms">
                {props.canDelete
                  ? window.APP.LANGUAGE.DeleteWaitingAreaModal.DeleteWaitingAreaInfo1
                  : window.APP.LANGUAGE.DeleteWaitingAreaModal.CannotDeleteWaitingAreaHeader}
              </h4>
              <div className="title-sms mrbm">
                {props.canDelete
                  ? window.APP.LANGUAGE.DeleteWaitingAreaModal.DeleteWaitingAreaInfo2
                  : window.APP.LANGUAGE.DeleteWaitingAreaModal.CannotDeleteWaitingAreaInfo}
              </div>
              <div className="ui actions max-width">
                {props.canDelete ? (
                  <button
                    type="button"
                    id="remove-save-btn"
                    onClick={confirmDeleteWA}
                    className={deletingWA ? removeBtnClasses + ' loading remove-save-btn' : removeBtnClasses}
                  >
                    {APP.LANGUAGE.Delete}
                    <i className="checkmark icon " />
                  </button>
                ) : (
                  ''
                )}
                <button
                  type="button"
                  id="remove-cancel-btn"
                  onClick={closeConfirmationModal}
                  className="ui cancel mrtm labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width  mrlnull mrbnull mrrnull"
                >
                  <i className="remove  icon" />
                  {APP.LANGUAGE.Cancel}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

WaitingAreaDeleteWAModal.propTypes = {
  waitingArea: PropTypes.object.isRequired,
  canDelete: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};
